// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE = "Dny se zna\u010dkou";
export const FORUM_COMMON_PLACE = "M\u00edsto, kde \u017eiji";
export const FORUM_TOPICS_NOT_FOUND_query = "Nena\u0161la se \u017e\u00e1dn\u00e1 f\u00f3ra se slovem \"%(query)s\".";
export const LIST_OF_FORUMS_BLUEHORSE = "Modr\u00fd kon\u00edk";
export const LOAD_PREVIOUS = "Na\u010d\u00edst p\u0159edch\u00e1zej\u00edc\u00ed";
export const NEW_FEMININE = "Nov\u00e1";
